function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".income-ic_svg__st0{fill:none;stroke:#00d280;stroke-width:1.5}");

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "income-ic_svg__Oval-6-Copy",
  className: "income-ic_svg__st0",
  cx: 12,
  cy: 12,
  r: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "income-ic_svg___x21_",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#00d280",
  d: "M11.2 16.5h1.6v-9h-1.6z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "income-ic_svg__st0",
  d: "M9 13.5l3 3 3-3"
});

function SvgIncomeIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "income-ic_svg__Layer_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "399f714d186e298fde9a7b2e980ce977.svg";
export { SvgIncomeIc as ReactComponent };